import { useEffect, useState } from 'react';
import { ValidDataService } from '../../../../service/validDataService';
import { formatDateWithTimezone } from '../../../../utils';

export const useValidInventoryAccessoryColumns = () => {
    const [locations, setLocations] = useState([]);
    const [brands, setBrands] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {

        // fetch suppliers based on the type of inventory item
        const fetchSuppliers = async () => {
            try {
                const response = await ValidDataService.getValidSupplierFilterOptions('accessories');
                const { code, data } = response;
                if (code === 0) {
                    // Transform brands into the format expected by the filter
                    const brandOptions = data.map(brand => ({
                        value: brand.value,
                        label: brand.label
                    }));
                    setSuppliers(brandOptions);
                }
            } catch (error) {
                console.error('Error fetching brands:', error);
            }
        };

        // fetch brands based on the type of inventory item
        const fetchBrands = async () => {
            try {
                const response = await ValidDataService.getValidBrandFilterOptions('accessories');
                const { code, data } = response;
                if (code === 0) {
                    // Transform brands into the format expected by the filter
                    const brandOptions = data.map(brand => ({
                        value: brand.value,
                        label: brand.label
                    }));
                    setBrands(brandOptions);
                }
            } catch (error) {
                console.error('Error fetching brands:', error);
            }
        };

        const fetchLocations = async () => {
            try {
                const response = await ValidDataService.getInventoryLocationFilterOptions('accessories');
                const { code, data } = response;
                if (code === 0) {
                    // Transform locations into the format expected by the filter
                    const locationOptions = data.map(loc => ({
                        value: loc.value,
                        label: loc.label
                    }));
                    setLocations(locationOptions);
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
            }
        };

        fetchLocations();
        //fetchBrands();
        fetchSuppliers();

    }, []);

    return [
        {
            Header: 'Description',
            accessor: 'modelNumber',
            enableFilter: true
        },
        {
            Header: 'Brand',
            accessor: 'brand.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: brands
        },
        {
            Header: 'Supplier',
            accessor: 'supplier.supplierName',
            enableFilter: true,
            type: 'enum',
            filterOptions: suppliers
        },
        {
            Header: 'SKU',
            accessor: 'sku',
            enableFilter: true,
        },        
        {
            Header: 'List Price',
            accessor: 'listPrice',
            enableFilter: true,
            type: 'number'
        },
        {
            Header: 'Location',
            accessor: 'location.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: locations
        },
    ];
};